import React from 'react';
import { twMerge } from 'tailwind-merge';

const Loader = ({ className = '' }) => {
  return (
    <div
      className={twMerge(
        'loader-wrapper fixed w-full h-screen flex items-center justify-center',
        className
      )}
    >
      <div className="loader--ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
